<!-- 兑换中心 -->
<template>
    <div class="exchangeCenter">
        <div class="input_box">
            <el-input placeholder="请输入兑换码" v-model="exchangecode"></el-input>
            <el-button type="primary" @click="validationRedeemcodeInfo">兑换</el-button>
        </div>
        <el-table :data="tableData" width="100%">
            <el-table-column label="商品信息" width="400px">
                <template slot-scope="scope">
                    <div class="goods_msg">
                        <div class="left_img_box">
                            <img :src="scope.row.kmccoverurl" alt="">
                        </div>
                        <div class="right_msg">
                            <el-tooltip class="item" effect="dark" :content="scope.row.kmcname" placement="top">
                                <p class="name">{{scope.row.kmcname}}</p>
                            </el-tooltip>
                            <div class="price">
                                <span class="saleprice">￥{{scope.row.saleprice}}</span>
                                <span class="uprice" v-if="scope.row.uprice > scope.row.saleprice">￥{{scope.row.uprice}}</span>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="分类" prop="kmctypename"></el-table-column>
            <el-table-column label="有效期限" class-name="validaty" width="200px">
                <template slot-scope="scope">
                    <span v-if="scope.row.kmcexpiretimetype === 1" class="isperpetual">{{scope.row.kmcexpiretime}}</span>
                    <span v-else-if="scope.row.kmcexpiretimetype === 2" class="validatynum">{{scope.row.kmcexpiretime}}</span>
                    <span v-else>{{scope.row.kmcexpiretime}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" class-name="right handle">
                <template slot-scope="scope">
                    <span @click="checkDetails(scope.row)" class="checkDetails">查看详情</span>
                </template>
            </el-table-column>
        </el-table>
        <Page @currentChange="pageChange" :total="page.total" ref="page" :page="page" />
        <el-dialog title=" " class="failDialog" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :visible.sync="failDialog" width="380px" center>
            <div class="fail_box">
                <img :src="require('@/common/images/header/error.png')" alt="">
                <p>兑换码错误，请重新输入！</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="failDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title=" " class="exchangeDialog" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :visible.sync="exchangeDialog" width="380px" center>
            <div class="exchange_box">
                <div class="goods_msg">
                    <div class="left_img"><img :src="exchangeGoodsMsg.kmccoverurl" alt=""></div>
                    <div class="right_msg">
                        <p class="goods_name">{{exchangeGoodsMsg.kmcname}}</p>
                        <p class="goods_type">{{exchangeGoodsMsg.kmctypename}}</p>
                    </div>
                </div>
                <div class="goods_price">
                    <span class="name">商品价格：</span>
                    <span class="sale_price">￥{{exchangeGoodsMsg.saleprice}}</span>
                    <span class="uprice" v-if="exchangeGoodsMsg.uprice > exchangeGoodsMsg.saleprice">￥{{exchangeGoodsMsg.uprice}}</span>
                </div>
                <div class="validaty">
                    兑换有效期：{{exchangeGoodsMsg.kmcexpiretime}}
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="exchangeDialog = false">取消</el-button>
                <el-button type="primary" @click="uploadRedeemcodeInfo">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Page from '../../components/page'
import {getExistingRedeemcodeList, validationRedeemcodeInfo, uploadRedeemcodeInfo} from 'api/personalCenterApi'
import {mapActions} from 'vuex'
export default {
    data() {
        return {
            tableData: [],
            page: {
                total: 0,
                page: 1,
                pageSize: 10
            },
            failDialog: false,
            exchangeDialog: false,
            exchangecode: '',
            exchangeGoodsMsg: {}
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        this.getExistingRedeemcodeList()
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        getExistingRedeemcodeList() {
            this.setLoading(true)
            getExistingRedeemcodeList({
                data: this.page,
                success: res => {
                    this.setLoading(false)
                    this.tableData = res.data.content
                    this.page.total = res.data.pageinfo.rowCount
                    console.log(res)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        validationRedeemcodeInfo() {
            this.setLoading(true)
            validationRedeemcodeInfo({
                data: {codevalue: this.exchangecode},
                success: res => {
                    this.setLoading(false)
                    if (!res.data.isvalid) {
                        this.failDialog = true
                    } else {
                        this.exchangeGoodsMsg = res.data
                        this.exchangeDialog = true
                    }
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        uploadRedeemcodeInfo() {
            this.setLoading(true)
            uploadRedeemcodeInfo({
                data: {kmcinnerid: this.exchangeGoodsMsg.kmcinnerid, kmctype: this.exchangeGoodsMsg.kmctype, ordermoney: this.exchangeGoodsMsg.saleprice, redeemcodevalue: this.exchangecode},
                success: () => {
                    this.setLoading(false)
                    this.exchangeDialog = false
                    this.page.page = 1
                    this.setPage({page: 1, pagesize: 10})
                    this.$message.success('兑换成功')
                    this.exchangecode = ''
                    this.getExistingRedeemcodeList()
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        pageChange(page) {
            this.page.page = page.page
            this.getExistingRedeemcodeList()
        },
        checkDetails(row) {
            window.open(row.detailurlPc)
        },
        ...mapActions([
            'setLoading',
            'setPage'
        ])
    },
    components: {
        Page
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .exchangeCenter {
        padding: 20px 30px;
        background: #fff;
        .input_box {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .el-input {
                width: 244px;
                height: 36px;
                .el-input__inner {
                    height: 36px;
                }
            }
            .el-button {
                width: 80px;
                height: 36px;
                margin-left: 20px;
                padding: 0;
                line-height: 36px;
            }
        }
        .el-table {
            .cell {
                color: #333333;
                font-size: 14px;
            }
            .goods_msg {
                display: flex;
                .left_img_box {
                    width: 110px;
                    height: 62px;
                    margin-right: 12px;
                    img {
                        width: 110px;
                        height: 62px;
                        border-radius: 4px;
                    }
                }
                .right_msg {
                    .name {
                        font-size: 14px;
                        line-height: 20px;
                        // margin-bottom: 4px;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        word-break: break-all;
                        color: #333333;
                    }
                    .price {
                        font-size: 14px;
                        .saleprice {
                            color: #FF4747;
                        }
                        .uprice {
                            color: #999999;
                            text-decoration: line-through;
                            margin-left: 4px;
                        }
                    }
                }
            }
            .validaty {
                .isperpetual {
                    color: #63CB89;
                }
                .validatynum {
                    color: #EC5E69;
                }
            }
            .right {
                .cell {
                    text-align: right;
                }
            }
            .handle {
                .checkDetails {
                    color: #409EFF;
                    cursor: pointer;
                }
            }
        }
        .failDialog {
            .el-dialog {
                border-radius: 4px;
                .fail_box {
                    text-align: center;
                    img {
                        width: 42px;
                        height: 42px;
                        margin: 0 auto 22px;
                    }
                }
                .el-dialog__footer {
                    .dialog-footer {
                        .el-button {
                            width: 100px;
                            height: 30px;
                            padding: 0;
                        }
                    }
                }
            }
        }
        .exchangeDialog {
            .el-dialog {
                .el-dialog__body {
                    padding: 0 30px 20px;
                    .exchange_box {
                        .goods_msg {
                            display: flex;
                            margin-bottom: 20px;
                            .left_img {
                                margin-right: 12px;
                                img {
                                    width: 110px;
                                    height: 62px;
                                    border-radius: 4px;
                                }
                            }
                            .right_msg {
                                .goods_name {
                                    text-overflow: -o-ellipsis-lastline;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 2;
                                    -webkit-box-orient: vertical;
                                    word-break: break-all;
                                    font-size: 14px;
                                    line-height: 20px;
                                    margin-bottom: 4px;
                                }
                                .goods_type {
                                    font-size: 14px;
                                    color: #999999;
                                }
                            }
                        }
                        .goods_price {
                            font-size: 14px;
                            line-height: 20px;
                            margin-bottom: 12px;
                            .name {
                                color: #333333;
                            }
                            .sale_price {
                                color: #EC5E69;
                                margin-right: 6px;
                            }
                            .uprice {
                                color: #999999;
                                text-decoration: line-through;
                            }
                        }
                        .validaty {
                            font-size: 14px;
                            line-height: 20px;
                        }
                    }
                }
                .el-dialog__footer {
                    .el-button {
                        width: 100px;
                        height: 30px;
                        padding: 0;
                    }
                    .el-button--primary {
                        margin-left: 20px;
                    }
                    .el-button--default {
                        color: #999999;
                    }
                }
            }
        }
    }
</style>